<template>
  <nav class="main-nav navbar navbar-expand-md navbar-light bg-light">
    <span class="d-none d-sm-block text-muted">{{ bandName }}</span>

    <div class="collapse navbar-collapse navbar-expand justify-content-end" id="navbarNavDropdown">
      <ul class="navbar-nav ml-auto mt-lg-0">
        <li class="nav-item" id="nav-events">
          <router-link class="nav-link" :to="`/events`"><ion-icon class="ion-icon-btn-align"
              name="calendar-outline"></ion-icon> Events</router-link>
        </li>
        <li v-if="enableResale" class="nav-item" id="nav-marketplace">
          <router-link class="nav-link" :to="`/marketplace`"><ion-icon class="ion-icon-btn-align"
              name="storefront-outline"></ion-icon> Marketplace</router-link>
        </li>
        <li class="nav-item" id="nav-signin">
          <router-link class="nav-link" to="/signin"><ion-icon class="ion-icon-btn-align"
              name="log-in-outline"></ion-icon> Sign in</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "LoggedOutNavBar",
  created () {
    this.$store.dispatch('settings/getAppSettings')
  },
  computed: {
    ...mapGetters('settings', ['bandName', 'enableResale'])
  }
}
</script>
<style scoped>

.main-nav{
  padding: 0.5rem 1rem !important;
}  
</style>